var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "row", attrs: { id: "offer-in-cart" } },
        [
          _vm.overwriteOfferImage
            ? [
                _c(_vm.overwriteOfferImage, {
                  tag: "component",
                  attrs: { id: "offer-svg" },
                }),
              ]
            : _vm.offer.offerImage
            ? [
                _c("img", {
                  staticClass: "col xs-2",
                  attrs: {
                    id: "offer-image",
                    src:
                      _vm.offer.offerImage ||
                      _vm.webstoreContent.noProductImage.fields.file.url,
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isAccountCreatedAfterTitan && _vm.smallFleetOpportunity
            ? _c(
                "div",
                { staticClass: "col xs-6", attrs: { id: "offer-info" } },
                [
                  _c("div", { attrs: { id: "offer-name" } }, [
                    _vm._v(_vm._s(_vm.offer.offerName)),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "offer-price" } }, [
                    _vm._v(
                      _vm._s(_vm.currencySymbol.toUpperCase()) +
                        _vm._s(
                          (
                            _vm.calculateTotalPrice(_vm.offer.salesPrice) *
                            _vm.offer.quantity
                          )
                            .toFixed(2)
                            .toLocaleString("en-US")
                        ) +
                        " " +
                        _vm._s(_vm.currencyIsoCode) +
                        "\n                "
                    ),
                    _vm.offer.offerType.toLowerCase().includes("license")
                      ? _c("span", { staticClass: "offer-payment-plan" }, [
                          _vm._v(" for 3-year license "),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            : _c(
                "div",
                { staticClass: "col xs-6", attrs: { id: "offer-info" } },
                [
                  _c("div", { attrs: { id: "offer-name" } }, [
                    _vm._v(_vm._s(_vm.offer.offerName)),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "offer-price" } }, [
                    _vm._v(
                      _vm._s(_vm.currencySymbol.toUpperCase()) +
                        _vm._s(
                          (
                            _vm.calculateTotalPrice(_vm.offer.salesPrice) *
                            _vm.offer.quantity
                          )
                            .toFixed(2)
                            .toLocaleString("en-US")
                        ) +
                        " " +
                        _vm._s(_vm.currencyIsoCode)
                    ),
                  ]),
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row col xs-4 flex flex-between",
              attrs: { id: "quantity-container" },
            },
            [
              _c(
                "div",
                { staticClass: "col xs-4", attrs: { id: "quantity-label" } },
                [
                  _vm._v(
                    _vm._s(_vm.webstoreContent?.quantityAbbreviation || "qty") +
                      ": " +
                      _vm._s(_vm.offer.quantity)
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.editable
                ? _c("div", {
                    staticClass: "col xs-1 close",
                    attrs: { id: "remove-offer" },
                    on: {
                      click: function ($event) {
                        return _vm.handleRemoveOfferClick(_vm.offer)
                      },
                    },
                  })
                : _vm._e(),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ul",
        { attrs: { id: "items-included-list" } },
        [
          _vm._l(_vm.sortedOffers, function (bullet) {
            return _c(
              "div",
              {
                key: bullet,
                staticClass:
                  "row flex flex-align-center item-included-container",
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "col xs-2 l-shape-pointer",
                    attrs: {
                      width: "23",
                      height: "23",
                      viewBox: "0 0 23 23",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("line", {
                      attrs: {
                        x1: "0.5",
                        y1: "2.18557e-08",
                        x2: "0.499999",
                        y2: "23",
                        stroke: "black",
                      },
                    }),
                    _c("line", {
                      attrs: {
                        y1: "22.5",
                        x2: "23",
                        y2: "22.5",
                        stroke: "black",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "col xs-9 item-included" }, [
                  _vm._v(_vm._s(bullet.replace("[", "(").replace("]", ")"))),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _vm.areCablesInOffer
            ? [
                _c("v-button", {
                  attrs: {
                    id: "cable-details-container",
                    position: "left",
                    mobile: "7",
                    tablet: "7",
                    desktop: "7",
                    styling: "tertiary",
                    disabled: false,
                    height: "auto",
                    textAlign: "left",
                  },
                  on: { onClickEvent: _vm.toggleCableDetailsDisplay },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "span",
                              { staticClass: "flex cable-flex-wrapper" },
                              [
                                _c(
                                  "span",
                                  { attrs: { id: "cable-details-text" } },
                                  [_vm._v(_vm._s(_vm.cableDisplayText))]
                                ),
                                _vm._v(" "),
                                _vm.displayCableDetails
                                  ? [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "arrow-position",
                                          attrs: {
                                            fill: "none",
                                            height: "20",
                                            viewBox: "0 0 20 20",
                                            width: "20",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "m14.1618 13.0432-4.17379-4.08157-4.17375 4.08157c-.18336.1732-.42895.269-.68386.2668s-.49876-.1021-.67902-.2784c-.18025-.1763-.2825-.4147-.28472-.664-.00221-.2493.09578-.4895.27288-.6688l4.86111-4.75369c.18232-.17823.42956-.27836.68736-.27836.25779 0 .50509.10013.68739.27836l4.8611 4.75369c.0928.0877.1669.1926.2179.3086.0509.116.0777.2408.0789.367.0011.1263-.0235.2514-.0724.3683-.0489.1168-.1211.223-.2124.3122-.0912.0893-.1998.1599-.3193.2077s-.2475.0719-.3766.0708-.2566-.0273-.3753-.0772c-.1186-.0498-.2259-.1222-.3155-.213z",
                                              fill: "#0d6ede",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "arrow-position",
                                          attrs: {
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M5.83824 6.95696L10.012 11.0385L14.1857 6.95696C14.3691 6.78377 14.6147 6.68794 14.8696 6.69011C15.1245 6.69227 15.3684 6.79226 15.5486 6.96854C15.7289 7.14481 15.8311 7.38327 15.8333 7.63255C15.8356 7.88183 15.7376 8.12199 15.5605 8.3013L10.6993 13.055C10.517 13.2332 10.2698 13.3334 10.012 13.3334C9.75419 13.3334 9.50695 13.2332 9.32463 13.055L4.46352 8.3013C4.37066 8.2136 4.29659 8.10869 4.24564 7.9927C4.19469 7.8767 4.16787 7.75195 4.16674 7.62571C4.16562 7.49947 4.19022 7.37428 4.23911 7.25743C4.28799 7.14059 4.36018 7.03444 4.45147 6.94517C4.54275 6.8559 4.6513 6.78531 4.77078 6.7375C4.89027 6.6897 5.01829 6.66565 5.14738 6.66674C5.27647 6.66784 5.40404 6.69407 5.52266 6.74389C5.64127 6.79372 5.74855 6.86615 5.83824 6.95696Z",
                                              fill: "#0D6EDE",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4042305257
                  ),
                }),
                _vm._v(" "),
                _vm.displayCableDetails
                  ? _c(
                      "div",
                      { staticClass: "cable-info-container padding-top" },
                      [
                        _c(
                          "ul",
                          _vm._l(_vm.offer.cables, function (cableInfo) {
                            return _c(
                              "li",
                              {
                                key: cableInfo.customerInput,
                                staticClass: "padding-bottom cable-bullets",
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.cableSkuToNames(
                                        cableInfo.cable.replace("-BUNDLE", "")
                                      )
                                    ) +
                                      " (" +
                                      _vm._s(
                                        cableInfo.cable.replace("-BUNDLE", "")
                                      ) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.typeOfCableSelectionText(
                                        cableInfo.type,
                                        cableInfo.customerInput
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.webstoreContent?.selectProductsPage
                                        ?.quantity_abbreviation || "qty"
                                    ) +
                                      ": " +
                                      _vm._s(cableInfo.quantity)
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.editable
        ? [
            _c("v-button", {
              attrs: {
                position: "right",
                mobile: "4",
                tablet: "3",
                desktop: "3",
                styling: "tertiary",
                disabled: false,
              },
              on: {
                onClickEvent: function ($event) {
                  return _vm.handleProductEditButtonClick(_vm.offer)
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "underline" }, [
                          _vm._v(
                            _vm._s(
                              _vm.webstoreContent.selectProductsPage.edit_item
                            )
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1363287462
              ),
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }